import { Injectable } from '@angular/core';

import { AjudaPage } from '../pages/ajuda/ajuda';

import { EspeciesProcessuaisPage } from '../pages/especies-processuais/especies-processuais';
import { CadastroPerguntasPage } from '../pages/cadastro-perguntas/cadastro-perguntas';
import { RolResponsaveisPage } from '../pages/modulos/rol-responsaveis/rol-responsaveis';
import { DadosGeraisPage } from '../pages/dados-gerais/dados-gerais';
import { CertificadoPage } from '../pages/certificado/certificado';
import { GestaoPCAPage } from '../pages/modulos/gestao-pca/gestao-pca';
import { TiposIrregularidadesPage } from '../pages/tipos-irregularidades/tipos-irregularidades';
import { CargoPage } from '../pages/cargo/cargo';

import { ArquivosPage } from '../pages/modulos/arquivos/arquivos';
import { BensServicosPage } from '../pages/bens-servicos/bens-servicos';
import { LicitacaoResumoAnalisePage } from '../pages/modulos/licitacao/resumo-analise/resumo-analise';
import { DirecionamentoFornecedoresPage } from '../pages/modulos/licitacao/direcionamento-fornecedores/direcionamento-fornecedores';
import { VisaoGerencialPage } from '../pages/modulos/licitacao/visao-gerencial/visao-gerencial';
import { BensServicosConviteTomadaConcorrenciaPage } from '../pages/modulos/licitacao/bens-servicos-convite-tomada-concorrencia/bens-servicos-convite-tomada-concorrencia';
import { BensServicosNaoEnquadramPage } from '../pages/modulos/licitacao/bens-servicos-nao-enquadram/bens-servicos-nao-enquadram';
import { DispensaLicitacaoIncompativelPage } from '../pages/modulos/licitacao/dispensa-licitacao-incompativel/dispensa-licitacao-incompativel';
import { InexigibilidadePage } from '../pages/modulos/licitacao/inexigibilidade/inexigibilidade';
import { LicitacaoRelatorioInspecaoPage } from '../pages/modulos/licitacao/relatorio-inspecao/relatorio-inspecao';
import { OutrosServicosLimiteDispensaPage } from '../pages/modulos/licitacao/outros-servicos-limite-dispensa/outros-servicos-limite-dispensa';
import { ModalidadeVersusContratadoPage } from '../pages/modulos/licitacao/modalidade-versus-contratado/modalidade-versus-contratado';
import { ObrasAcimaLimitePage } from '../pages/modulos/licitacao/obras-acima-limite/obras-acima-limite';

import { PessoalResumoAnalisePage } from '../pages/modulos/pessoal/resumo-analise/resumo-analise';
import { PessoalAnaliseHorizontalPage } from '../pages/modulos/pessoal/analise-horizontal/analise-horizontal';
import { PessoalAnaliseVerticalPage } from '../pages/modulos/pessoal/analise-vertical/analise-vertical';
import { PessoalNomeacaoVersusParametrizacaoPage } from '../pages/modulos/pessoal/nomeacao-versus-parametrizacao/nomeacao-versus-parametrizacao';
import { PessoalNomeacaoVersusSRPPage } from '../pages/modulos/pessoal/nomeacao-versus-srp/nomeacao-versus-srp';
import { PessoalVersusNomeacaoPage } from '../pages/modulos/pessoal/pessoal-versus-nomeacao/pessoal-versus-nomeacao';
import { PessoalQuadroPessoalPage } from '../pages/modulos/pessoal/quadro-pessoal/quadro-pessoal';
import { PessoalTermosReferenciaContratoPage } from '../pages/modulos/pessoal/termos-referencia-contrato/termos-referencia-contrato';
import { VisaoGerencialPessoalPage } from '../pages/modulos/pessoal/visao-gerencial/visao-gerencial';
import { VisaoGerencialElemento31Page } from '../pages/modulos/pessoal/visao-gerencial-elemento-31/visao-gerencial-elemento-31';

import { PessoalQuadroNomeacaoCargosPage } from '../pages/modulos/pessoal/quadro-nomeacao-cargos/quadro-nomeacao-cargos';
import { PessoalDemQuadroPessoallPage } from '../pages/modulos/pessoal/dem-quadro-pessoal/dem-quadro-pessoal';
import { PessoalContratosTerceirizacaolPage } from '../pages/modulos/pessoal/contratos-terceirizacao/contratos-terceirizacao';

import { MonitoramentoDecisoesResumoAnalisePage } from '../pages/modulos/monitoramento-decisoes/resumo-analise/resumo-analise';
import { MonitoramentoDecisoesPage } from '../pages/modulos/monitoramento-decisoes/determinacoes/determinacoes';

import { TomadaDeContaResumoAnalisePage } from '../pages/modulos/tce/tce-resumo-acoes/tce-resumo-acoes';
import { TomadaDeContaPage } from '../pages/modulos/tce/tce-exercicio/tce-exercicio';

// **
// ** CONVÊNIOS
// **
import { ConvenioResumoAnalisePage } from '../pages/modulos/convenios/resumo-analise/resumo-analise';
import { ConvenioRelacaoCelebradosPage } from '../pages/modulos/convenios/relacao-celebrados/relacao-celebrados';
import { ConvenioComunicacaoInadimplenciaPage } from '../pages/modulos/convenios/comunicacao-inadimplencia/comunicacao-inadimplencia';
import { ResumoRelatorioInspecaoConveniosPage } from '../pages/modulos/convenios/convenio-analise/resumo-relatorio-inspecao/resumo-relatorio-inspecao';
import { CelebracaoInadimplentePage } from '../pages/modulos/convenios/convenio-analise/celebracao-inadimplente/celebracao-inadimplente';
import { ParcelaUnicaPage } from '../pages/modulos/convenios/convenio-analise/parcela-unica/parcela-unica';
import { ApresentacaoFPrazoPage } from '../pages/modulos/convenios/convenio-analise/apresentacao-fora-prazo/apresentacao-fora-prazo';
import { SaldoRemanescentePage } from '../pages/modulos/convenios/convenio-analise/saldo-remanescente/saldo-remanescente';
import { PrestacaoSuperiorPage } from '../pages/modulos/convenios/convenio-analise/prestacao-superior/prestacao-superior';
import { SaldosADevolverPage } from '../pages/modulos/convenios/convenio-analise/saldo-a-devolver/saldo-a-devolver'
import { PrestacaoForaPrazoPage } from '../pages/modulos/convenios/convenio-analise/prestacao-fora-prazo/prestacao-fora-prazo';
import { CelebracaoAtrasoPage } from '../pages/modulos/convenios/convenio-analise/celebracao-atraso/celebracao-atraso';
import { RegistroIncorretoPage } from '../pages/modulos/convenios/convenio-analise/registro-incorreto/registro-incorreto';
import { ConveniosInadimplenciaPage } from '../pages/modulos/convenios/convenio-analise/convenios-inadimplencia/convenios-inadimplencia';
import { ComunicacaoInadimplenciaPage } from '../pages/modulos/convenios/convenio-analise/comunicacao-inadimplencia/comunicacao-inadimplencia';
import { DesconformidadePublicacaoPage } from '../pages/modulos/convenios/convenio-analise/desconformidade-publicacao/desconformidade-publicacao';
import { EmpenhoAssinaturaPage } from '../pages/modulos/convenios/convenio-analise/empenho-assinatura/empenho-assinatura';
import { EmpenhoPublicacaoPage } from '../pages/modulos/convenios/convenio-analise/empenho-publicacao/empenho-publicacao';
import { EmpenhoVigenciaPage } from '../pages/modulos/convenios/convenio-analise/empenho-vigencia/empenho-vigencia';
import { RelatorioAuditoriaCGEPage } from '../pages/modulos/convenios/convenio-analise/relatorio-auditoria-cge/relatorio-auditoria-cge';
import { MedidasForaPrazoPage } from '../pages/modulos/convenios/convenio-analise/medidas-fora-prazo/medidas-fora-prazo';

import { MateriaisResumoAnalisePage } from '../pages/modulos/materiais/resumo-analise/resumo-analise';
import { MateriaisConsumoPage } from '../pages/modulos/materiais/materiais-consumo/materiais-consumo';
import { BensMateriaisMoveisPage } from '../pages/modulos/materiais/bens-moveis/bens-moveis';
import { BensMateriaisImoveisPage } from '../pages/modulos/materiais/bens-imoveis/bens-imoveis';
import { BensMateriaisIntangiveisPage } from '../pages/modulos/materiais/bens-intangiveis/bens-intangiveis';

import { AlienacaoBensMoveisPage } from '../pages/modulos/materiais/alienacao-bens-moveis/alienacao-bens-moveis';
import { AlienacaoBensImoveisPage } from '../pages/modulos/materiais/alienacao-bens-imoveis/alienacao-bens-imoveis';
import { BensDoacaoPage } from '../pages/modulos/materiais/bens-doacao/bens-doacao';

import { LoginPage } from '../pages/login/login';
import { LogoutPage } from '../pages/logout/logout';

import { ProcessosCorrelatosPage } from '../pages/modulos/processos-correlatos/processos-correlatos';
import { ControlesInternosPage } from '../pages/modulos/controles-internos/controles-internos';
import { ContabilidadeResumoAnalisePage } from '../pages/modulos/relatorios-contabeis/resumo-acoes/resumo-acoes';
import { OrcamentoResumoAnalisePage } from '../pages/modulos/orcamento/resumo-acoes/resumo-acoes';
import { ContasBancariasPage } from '../pages/modulos/relatorios-contabeis/contas-bancarias/contas-bancarias';
import { ContratosPage } from '../pages/modulos/contratos/contratos';

import { ContratosGestaoResumoAnalisePage } from '../pages/modulos/contratos-gestao/resumo-acoes/resumo-acoes';
import { CadastroContratosPage } from '../pages/modulos/contratos-gestao/cadastro-contratos/cadastro-contratos';
import { RolResponsaveisCGPage } from '../pages/modulos/contratos-gestao/rol-responsaveis/rol-responsaveis';
import { TransferenciaRecursosPage } from '../pages/modulos/contratos-gestao/transferencia-recursos/transferencia-recursos';
import { RelatorioReceitasDespesasPage } from '../pages/modulos/contratos-gestao/relatorio-receitas-despesas/relatorio-receitas-despesas';
import { RelatorioPagamentosPage } from '../pages/modulos/contratos-gestao/relatorio-pagamentos/relatorio-pagamentos';
import { RelatorioFisicoFinanceiroPage } from '../pages/modulos/contratos-gestao/relatorio-fisico-financeiro/relatorio-fisico-financeiro';
import { RelatorioEditaisCotacoesPage } from '../pages/modulos/contratos-gestao/relatorio-editais-cotacoes/relatorio-editais-cotacoes';
import { PessoalVinculadoPage } from '../pages/modulos/contratos-gestao/pessoal-vinculado/pessoal-vinculado';

import { VerificacaoRolPage } from '../pages/modulos/contratos-gestao/analista/verificacao-rol/verificacao-rol';
import { AnaliseDespesasPage } from '../pages/modulos/contratos-gestao/analista/analise-despesas/analise-despesas';
import { PagamentosDesacordoCompraPage } from '../pages/modulos/contratos-gestao/analista/pagamentos-desacordo-compra/pagamentos-desacordo-compra';
import { PagamentosVsPessoalPage } from '../pages/modulos/contratos-gestao/analista/pagamentos-vs-pessoal/pagamentos-vs-pessoal';
import { ParcelasRecebidasVsEmpenhoPage } from '../pages/modulos/contratos-gestao/analista/parcelas-recebidas-vs-empenho/parcelas-recebidas-vs-empenho';
import { RelatorioFisicoPage } from '../pages/modulos/contratos-gestao/analista/relatorio-fisico/relatorio-fisico';
import { RelatorioReceitaDespesaPage } from '../pages/modulos/contratos-gestao/analista/relatorio-receita-despesa/relatorio-receita-despesa';
import { TransferenciaRecursosAnalistaPage } from '../pages/modulos/contratos-gestao/analista/transferencia-recursos/transferencia-recursos-analista';
import { VerificacaoContratacaoPage } from '../pages/modulos/contratos-gestao/analista/verificacao-contratacao/verificacao-contratacao';
import { ServidoresContempladosPagamentosPage } from '../pages/modulos/contratos-gestao/analista/servidores-contemplados-pagamentos/servidores-contemplados-pagamentos';
import { PessoalVinculadoCGPage } from '../pages/modulos/contratos-gestao/analista/pessoal-vinculado/pessoal-vinculado';



import { AnaliseHorizontalBalancoPatrimonialPage } from '../pages/modulos/modulo-analise/analise-horizontal/balanco-patrimonial/balanco-patrimonial';
import { AnaliseHorizontalBalancoDvpPage } from '../pages/modulos/modulo-analise/analise-horizontal/balanco-dvp/balanco-dvp';
import { AnaliseVerticalBalancoPatrimonialPage } from '../pages/modulos/modulo-analise/analise-vertical/balanco-patrimonial/balanco-patrimonial';
import { AnaliseHorizontalBalancoFinanceiroPage } from '../pages/modulos/modulo-analise/analise-horizontal/balanco-financeiro/balanco-financeiro';
import { AnaliseHorizontalDemonstrativoFluxoCaixaPage } from '../pages/modulos/modulo-analise/analise-horizontal/demonstrativo-fluxo-caixa/demonstrativo-fluxo-caixa';
import { ExecucaoRestosPagarPage } from '../pages/modulos/modulo-analise/execucao-restos-pagar/execucao-restos-pagar';
import { ValoresRestituiveisPage } from '../pages/modulos/modulo-analise/valores-restituiveis/valores-restituiveis';
import { SaldoCaixaPage } from '../pages/modulos/modulo-analise/saldo-caixa/saldo-caixa';
import { SaldoContaPage } from '../pages/modulos/modulo-analise/saldo-conta/saldo-conta';
import { ValidacaoConsistenciaBalancoDFCPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-dfc/balanco-dfc';
import { ValidacaoConsistenciaBalancoPatrimonialPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-patrimonial/balanco-patrimonial';
import { ValidacaoConsistenciaBalancoDVPPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-dvp/balanco-dvp';
import { ValidacaoConsistenciaBalancoFinanceiroPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-financeiro/balanco-financeiro';
import { CruzamentoBalancoFinanceiroPatrimonialPage } from '../pages/modulos/modulo-analise/cruzamento/balanco-financeiro-patrimonial/balanco-financeiro-patrimonial';
import { TotalRestosPagarNaoProcessadosPage } from '../pages/modulos/modulo-analise/total-restos-pagar-nao-processados/total-restos-pagar-nao-processados';
import { ExecucaoRestosPagarNaoProcessadosPage } from '../pages/modulos/modulo-analise/execucao-restos-pagar-nao-processados/execucao-restos-pagar-nao-processados';
import { AnaliseContasBancariasPage } from '../pages/modulos/modulo-analise/contas-bancarias/contas-bancarias';
import { SaldosDeclaradosPage } from '../pages/modulos/modulo-analise/saldos-declarados/saldos-declarados';

import { AnaliseHorizontalBalancoPatrimonialEGEPage } from '../pages/modulos/modulo-analise/analise-horizontal/balanco-patrimonial-ege/balanco-patrimonial';
import { AnaliseHorizontalBalancoDvpEGEPage } from '../pages/modulos/modulo-analise/analise-horizontal/balanco-dvp-ege/balanco-dvp';
import { AnaliseVerticalBalancoPatrimonialEGEPage } from '../pages/modulos/modulo-analise/analise-vertical/balanco-patrimonial-ege/balanco-patrimonial';
import { AnaliseVerticalBalancoPatrimonialSpedPage } from '../pages/modulos/modulo-analise/analise-vertical/balanco-patrimonial-sped/balanco-patrimonial';
import { SaldoContaSPEDPage } from '../pages/modulos/modulo-analise/saldo-conta-sped/saldo-conta';

import { AnaliseHorizontalBalancoFinanceiroEGEPage } from '../pages/modulos/modulo-analise/analise-horizontal/balanco-financeiro-ege/balanco-financeiro';
import { AnaliseHorizontalDemonstrativoFluxoCaixaEGEPage } from '../pages/modulos/modulo-analise/analise-horizontal/demonstrativo-fluxo-caixa-ege/demonstrativo-fluxo-caixa';
import { ExecucaoRestosPagarEGEPage } from '../pages/modulos/modulo-analise/execucao-restos-pagar-ege/execucao-restos-pagar';
import { ValoresRestituiveisEGEPage } from '../pages/modulos/modulo-analise/valores-restituiveis-ege/valores-restituiveis';
import { SaldoCaixaEGEPage } from '../pages/modulos/modulo-analise/saldo-caixa-ege/saldo-caixa';
import { SaldoContaEGEPage } from '../pages/modulos/modulo-analise/saldo-conta-ege/saldo-conta';
import { ValidacaoConsistenciaBalancoDFCEGEPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-dfc-ege/balanco-dfc';
import { ValidacaoConsistenciaBalancoPatrimonialEGEPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-patrimonial-ege/balanco-patrimonial';
import { ValidacaoConsistenciaBalancoPatrimonialSPEDPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-patrimonial-sped/balanco-patrimonial';

import { ValidacaoConsistenciaBalancoDVPEGEPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-dvp-ege/balanco-dvp';
import { ValidacaoConsistenciaBalancoFinanceiroEGEPage } from '../pages/modulos/modulo-analise/validacao-consistencia/balanco-financeiro-ege/balanco-financeiro';
import { CruzamentoBalancoFinanceiroPatrimonialEGEPage } from '../pages/modulos/modulo-analise/cruzamento/balanco-financeiro-patrimonial-ege/balanco-financeiro-patrimonial';
import { TotalRestosPagarNaoProcessadosEGEPage } from '../pages/modulos/modulo-analise/total-restos-pagar-nao-processados-ege/total-restos-pagar-nao-processados';
import { ExecucaoRestosPagarNaoProcessadosEGEPage } from '../pages/modulos/modulo-analise/execucao-restos-pagar-nao-processados-ege/execucao-restos-pagar-nao-processados';
import { AnaliseContasBancariasEGEPage } from '../pages/modulos/modulo-analise/contas-bancarias-ege/contas-bancarias';
import { SaldosDeclaradosEGEPage } from '../pages/modulos/modulo-analise/saldos-declarados-ege/saldos-declarados';

import { ListaContratosPage } from '../pages/modulos/contratos/contrato-analise/lista-contratos/lista-contratos';
import { ResumoRelatorioInspecaoPage } from '../pages/modulos/contratos/contrato-analise/resumo-relatorio-inspecao/resumo-relatorio-inspecao';
import { AcrescimosOuSupressoesContratosVersusLimiteLegalPage } from '../pages/modulos/contratos/contrato-analise/acrescimo-supressoes-contratos-versus-limite-legal/acrescimo-supressoes-contratos-versus-limite-legal';
import { ExtensaoPrazosContratuaisAcimaLimiteRegulamentadoPage } from '../pages/modulos/contratos/contrato-analise/extensao-prazos-contratuais-acima-limite-regulamentado/extensao-prazos-contratuais-acima-limite-regulamentado';
import { NotaEmpenhoAnteriorAAssinaturaContratoPage } from '../pages/modulos/contratos/contrato-analise/nota-empenho-anterior-assinatura-contrato/nota-empenho-anterior-assinatura-contrato';
import { NotaEmpenhoAnteriorAPublicacaoContratoPage } from '../pages/modulos/contratos/contrato-analise/nota-empenho-anterior-publicacao-contrato/nota-empenho-anterior-publicacao-contrato';
import { NotaEmpenhoPosteriorAVigenciaContratoPage } from '../pages/modulos/contratos/contrato-analise/nota-empenho-posterior-vigencia-contrato/nota-empenho-posterior-vigencia-contrato';
import { RegistroDespesasSemContratoDesacordoArt62Page } from '../pages/modulos/contratos/contrato-analise/registro-despesas-sem-contrato-desacordo-art62/registro-despesas-sem-contrato-desacordo-art62';
import { ValidacaoDataPublicacaoPage } from '../pages/modulos/contratos/contrato-analise/validacao-data-publicacao/validacao-data-publicacao';
import { RolAssinantesPage } from "../pages/modulos/rol-assinantes/rol-assinantes";
import { TCEConveniosPrestacaoPendentesPage } from "../pages/modulos/tce/tce-pendentes/tce-pendentes";
import { TCENaoEnviadoPage } from "../pages/modulos/tce/tce-nao-enviado/tce-nao-enviado";
import { TCEForaDoPrazoPage } from "../pages/modulos/tce/tce-fora-do-prazo/tce-fora-do-prazo";

import { diferencaDotacoesPage } from '../pages/modulos/orcamento/analista/diferencaDotacoes/diferencaDotacoes';
import { consolidacaoDespesasPage } from '../pages/modulos/orcamento/analista/consolidacaoDespesas/consolidacaoDespesas';
import { AnaliseMetasPage } from '../pages/modulos/orcamento/analista/analise-metas/analise-metas';
import { AquisicaoBensPage } from '../pages/modulos/orcamento/analista/aquisicaoBens/aquisicaoBens';
import { ExecucaoXMetasPage } from '../pages/modulos/orcamento/analista/execucaoXmetas/execucaoXmetas';
import { ExerciciosAnterioresPage } from '../pages/modulos/orcamento/analista/exerciciosAnteriores/exerciciosAnteriores';

import { BaixaVsAquisicaoPage } from '../pages/modulos/materiais/analista/baixa-vs-aquisicao/baixa-vs-aquisicao';
import { BaixaVsSaldoAtualPage } from '../pages/modulos/materiais/analista/baixa-vs-saldo/baixa-vs-saldo';
import { ReconhecimentoResultadoPage } from '../pages/modulos/materiais/analista/reconhecimento-resultado/reconhecimento-resultado';
import { AlienacoesDoacoesPage } from '../pages/modulos/materiais/analista/alienacoes-doacoes/alienacoes-doacoes';
import { SaldosContabeisPage } from '../pages/modulos/materiais/analista/saldos-contabeis/saldos-contabeis';
import { SaldosContabeisTabelasVsBalancetePage } from '../pages/modulos/materiais/analista/saldos-contabeis-tabelas-vs-balancete/saldos-contabeis-tabelas-vs-balancete';

import { ValidacaoContasTotalizadorasBalancoFinanceiroPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-financeiro/balanco-financeiro';
import { ValidacaoContasTotalizadorasBalancoOrcamentarioPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-orcamentario/balanco-orcamentario';
import { ValidacaoContasTotalizadorasBalancoPatrimonialPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-patrimonial/balanco-patrimonial';
import { ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/demonstrativo-fluxo-caixa/demonstrativo-fluxo-caixa';
import { ValidacaoContasTotalizadorasDVPPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-dvp/balanco-dvp';
import { AnalisePrevisaoInicialContasAnaliticasPage } from '../pages/modulos/modulo-analise/previsao-inicial-contas-analiticas/previsao-inicial-contas-analiticas';
import { AnaliseIndicadoresPage } from '../pages/modulos/modulo-analise/indicadores/indicadores';
import { ExecucaoRestosPagarProcessadosLiquidadosPage } from '../pages/modulos/modulo-analise/execucao-restos-pagar-processados-liquidados/execucao-restos-pagar-processados-liquidados';
import { AnaliseSaldosViradosDVPPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-dvp/saldos-virados-dvp';
import { AnaliseSaldosViradosFinanceiroPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-financeiro/saldos-virados-financeiro';
import { AnaliseSaldosViradosDemonstrativoFluxoCaixaPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-demonstrativo-fluxo-caixa/saldos-virados-demonstrativo-fluxo-caixa';
import { AnaliseSaldosViradosPatrimonialPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-patrimonial/saldos-virados-patrimonial';
import { AnaliseSaldosViradosPatrimonialSPEDPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-patrimonial-sped/saldos-virados-patrimonial-sped';
import { AnaliseSaldosViradosOrcamentarioPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-orcamentario/saldos-virados-orcamentario';
import { TotalRestosPagarProcessadosPage } from '../pages/modulos/modulo-analise/total-restos-pagar-processados/total-restos-pagar-processados';
import { SaldoContasAnaliticasPage } from '../pages/modulos/modulo-analise/saldo-contas-analiticas/saldo-contas-analiticas';
import { OrdinariaVsVinculadaPage } from '../pages/modulos/modulo-analise/ordinaria-vs-vinculada/ordinaria-vs-vinculada';

import { ValidacaoContasTotalizadorasBalancoFinanceiroEGEPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-financeiro-ege/balanco-financeiro';
import { ValidacaoContasTotalizadorasBalancoOrcamentarioEGEPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-orcamentario-ege/balanco-orcamentario';
import { ValidacaoContasTotalizadorasBalancoPatrimonialEGEPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-patrimonial-ege/balanco-patrimonial';
import { ValidacaoContasTotalizadorasBalancoPatrimonialSPEDPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-patrimonial-sped/balanco-patrimonial';
import { ValidacaoContasTotalizadorasDRESPEDPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/dre-sped/dre';

import { ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaEGEPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/demonstrativo-fluxo-caixa-ege/demonstrativo-fluxo-caixa';
import { ValidacaoContasTotalizadorasDVPEGEPage } from '../pages/modulos/modulo-analise/validacao-contas-totalizadoras/balanco-dvp-ege/balanco-dvp';
import { AnalisePrevisaoInicialContasAnaliticasEGEPage } from '../pages/modulos/modulo-analise/previsao-inicial-contas-analiticas-ege/previsao-inicial-contas-analiticas';
import { AnaliseIndicadoresEGEPage } from '../pages/modulos/modulo-analise/indicadores-ege/indicadores';
import { ExecucaoRestosPagarProcessadosLiquidadosEGEPage } from '../pages/modulos/modulo-analise/execucao-restos-pagar-processados-liquidados-ege/execucao-restos-pagar-processados-liquidados';
import { AnaliseSaldosViradosDVPEGEPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-dvp-ege/saldos-virados-dvp';
import { AnaliseSaldosViradosFinanceiroEGEPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-financeiro-ege/saldos-virados-financeiro';
import { AnaliseSaldosViradosDemonstrativoFluxoCaixaEGEPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-demonstrativo-fluxo-caixa-ege/saldos-virados-demonstrativo-fluxo-caixa';
import { AnaliseSaldosViradosPatrimonialEGEPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-patrimonial-ege/saldos-virados-patrimonial';

import { AnaliseSaldosViradosOrcamentarioEGEPage } from '../pages/modulos/modulo-analise/saldos-virados/saldos-virados-orcamentario-ege/saldos-virados-orcamentario';
import { TotalRestosPagarProcessadosEGEPage } from '../pages/modulos/modulo-analise/total-restos-pagar-processados-ege/total-restos-pagar-processados';
import { SaldoContasAnaliticasEGEPage } from '../pages/modulos/modulo-analise/saldo-contas-analiticas-ege/saldo-contas-analiticas';
import { OrdinariaVsVinculadaEGEPage } from '../pages/modulos/modulo-analise/ordinaria-vs-vinculada-ege/ordinaria-vs-vinculada';

import { AnaliseHorizontalBalancoPatrimonialSpedPage } from '../pages/modulos/modulo-analise/analise-horizontal/balanco-patrimonial-sped/balanco-patrimonial';


@Injectable()
export class APP_ROUTES_SERVICE {

  autorizacaoRolDeResponsaveis = '951';
  autorizacaoControlesInternos = '952';
  autorizacaoProcessosCorrelatos = '953';
  autorizacaoContabilidade = '954';
  autorizacaoContratos = '955';
  autorizacaoConvenios = '956';
  autorizacaoLicitacoes = '957';
  autorizacaoTomadaDeConta = '958';
  autorizacaoMonitoramentoDeDecisoes = '959';
  autorizacaoPessoal = '960';
  autorizacaoOrcamento = '961';
  autorizacaoGestaoDeMateriaisEPatrimonio = '962';
  autorizacaoParametrizacao = '963';
  autorizacaoGestaoPCA = '964';
  autorizacaoDadosGerais = '965';
  autorizacaoContratosDeGestao = '966';
  autorizacaoArquivos = '967';
  autorizacaoRolDeAssinantes = '968';
  autorizacaoCertificado = '969';

  constructor() {
  }

  LOGIN_PAGE: any =
    {
      Titulo: "Login",
      Component: LoginPage,
      Autorizacao: ["*"],
      NecessarioPCA: false
    }

  HOME_PAGE: any =
    {
      Titulo: "Gestão Pca",
      Icone: "briefcase",
      Component: GestaoPCAPage,
      Autorizacao: this.autorizacaoGestaoPCA,
      NecessarioPCA: false
    }

  LOGOUT_PAGE: any =
    {
      Titulo: "Sair",
      Icone: "briefcase",
      Component: LogoutPage,
      Autorizacao: "9999",
      NecessarioPCA: false
    }

  AJUDA_PAGE: any =
    {
      Titulo: "Ajuda",
      Icone: "briefcase",
      Component: AjudaPage,
      Autorizacao: "8888",
      NecessarioPCA: false
    }

  ROUTERS_TO_MENU: any[] = [
    //    {
    //         Titulo: "Pca",
    //         Icone: "",
    //         Autorizacao: ["*"],
    //         Paginas: [
    //             {
    //                 Titulo: "Gestão de Pca",
    //                 Icone: "briefcase",
    //                 Component: GestaoPCAPage,
    //                 Autorizacao: this.autorizacaoGestaoPCA,
    //                 NecessarioPCA: false
    //             },
    //             {
    //                 Titulo: "Dados Gerais",
    //                 Icone: "briefcase",
    //                 Component: DadosGeraisPage,
    //                 Autorizacao: this.autorizacaoDadosGerais,
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Controles Internos",
    //                 Icone: "clipboard",
    //                 Component: ControlesInternosPage,
    //                 Autorizacao: this.autorizacaoControlesInternos,
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Rol de Responsáveis",
    //                 Icone: "filing",
    //                 Component: RolResponsaveisPage,
    //                 Autorizacao: this.autorizacaoRolDeResponsaveis,
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Processos Correlatos",
    //                 Icone: "albums",
    //                 Component: ProcessosCorrelatosPage,
    //                 Autorizacao: this.autorizacaoProcessosCorrelatos,
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Contabilidade",
    //                 Icone: "cash",
    //                 Component: RelatoriosContabeisPage,
    //                 Autorizacao: this.autorizacaoContabilidade,
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Contratos",
    //                 Icone: "cash",
    //                 Component: ContratosPage,
    //                 Autorizacao: this.autorizacaoContratos,
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Orçamento",
    //                 Icone: "cash",
    //                 Component: OrcamentoPage,
    //                 Autorizacao: this.autorizacaoOrcamento,
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Relatórios Contábeis",
    //                 Icone: "cash",
    //                 Component: RelatoriosContabeisPage,
    //                 Autorizacao: ["*"],
    //                 NecessarioPCA: true
    //             },
    //             {
    //                 Titulo: "Arquivos Vinculados",
    //                 Icone: "cash",
    //                 Component: ArquivosPage,
    //                 Autorizacao: this.autorizacaoArquivos,
    //                 NecessarioPCA: true
    //             }
    //         ]
    //     },
    {
      Titulo: "Parametrização",
      Icone: "",
      Autorizacao: this.autorizacaoParametrizacao,
      Paginas: [
        {
          Titulo: "Cadastro Perguntas",
          Icone: "create",
          Component: CadastroPerguntasPage,
          Autorizacao: "*",
          Visivel: false
        },
        {
          Titulo: "Tipos de Irregularidades",
          Icone: "create",
          Component: TiposIrregularidadesPage,
          Autorizacao: "*",
          Visivel: false
        },
        {
          Titulo: "Espécies Processuais",
          Icone: "create",
          Component: EspeciesProcessuaisPage,
          Autorizacao: "*",
          Visivel: false
        },
        {
          Titulo: "Bens e Serviços Comuns",
          Icone: "create",
          Component: BensServicosPage,
          Autorizacao: "*",
          Visivel: false
        }
        // ,
        // {
        //     Titulo: "Cargos",
        //     Icone: "create",
        //     Component: CargoPage,
        //     Autorizacao: "*",
        //     Visivel: false
        // }
      ]
    }
    // {
    //     Titulo: "Certificado",
    //     Icone: "clipboard",
    //     Component: CertificadoPage,
    //     Autorizacao: ["adm"]
    // }
  ]

  APP_ROUTERS: any[] = [
    {
      Titulo: "Pca",
      Icone: "",
      Autorizacao: ["*"],
      Paginas: [
        {
          Titulo: "Gestão de Pca",
          Icone: "briefcase",
          Component: GestaoPCAPage,
          Autorizacao: this.autorizacaoGestaoPCA,
          NecessarioPCA: false
        },
        {
          Titulo: "Dados Gerais",
          Icone: "briefcase",
          Component: DadosGeraisPage,
          Autorizacao: this.autorizacaoDadosGerais,
          NecessarioPCA: true
        },
        {
          Titulo: "Certificado",
          Icone: "briefcase",
          Component: CertificadoPage,
          Autorizacao: this.autorizacaoCertificado,
          NecessarioPCA: true
        },
        {
          Titulo: "Licitações",
          Icone: "briefcase",
          Component: LicitacaoResumoAnalisePage,
          Autorizacao: this.autorizacaoLicitacoes,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Aquisiçao de Bens e Serviços Comuns por meio de Convite, Tomada de preços ou concorrência",
              Component: BensServicosConviteTomadaConcorrenciaPage,
              Autorizacao: "64"
            },
            {
              Titulo: "Aquisição de Outros Serviços e Compras Acima do limite de Dispensa de Licitação",
              Component: OutrosServicosLimiteDispensaPage,
              Autorizacao: "67"
            },
            {
              Titulo: "Bens e Serviços que não se Enquadram no Conceito de Comuns",
              Component: BensServicosNaoEnquadramPage,
              Autorizacao: "63"
            },
            {
              Titulo: "Contratação de Obras e Serviços de Engenharia Acima do Limite de Dispensa de Licitação",
              Component: ObrasAcimaLimitePage,
              Autorizacao: "66"
            },
            {
              Titulo: "Analisar Potenciais Direcionamento de Fornecedores",
              Component: DirecionamentoFornecedoresPage,
              Autorizacao: "70"
            },
            {
              Titulo: "Dispensa de Licitação incompatível com os dispositivos do Art.24, incisos III a XXIX da Lei Federal no8666/93",
              Component: DispensaLicitacaoIncompativelPage,
              Autorizacao: "68"
            },
            {
              Titulo: "Inexigibilidade de licitação incompatível com os dispositivos do Art.25, incisos I ao III da Lei Federal no 8666/93",
              Component: InexigibilidadePage,
              Autorizacao: "69"
            },
            {
              Titulo: "Modalidade de Licitação versus valor contrato",
              Component: ModalidadeVersusContratadoPage,
              Autorizacao: "65"
            },
            {
              Titulo: "Resumo dos Relatórios de Inspeção - Gerência Especializada",
              Component: LicitacaoRelatorioInspecaoPage,
              Autorizacao: "61"
            },
            {
              Titulo: "Visão Gerencial das Licitações",
              Component: VisaoGerencialPage,
              Autorizacao: "62"
            },
            {
              Titulo: "Upload de Peças Processuais",
              Component: ArquivosPage,
              Autorizacao: "60"
            }
          ]
        },
        {
          Titulo: "Monitoramento de Decisões",
          Icone: "briefcase",
          Component: MonitoramentoDecisoesResumoAnalisePage,
          Autorizacao: this.autorizacaoMonitoramentoDeDecisoes,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Recomendações e Determinações Expedidas",
              Component: MonitoramentoDecisoesPage,
              Autorizacao: "71"
            }
          ]
        },
        {
          Titulo: "Pessoal",
          Icone: "people",
          Component: PessoalResumoAnalisePage,
          Autorizacao: this.autorizacaoPessoal,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Análise Horizontal dos Cargos do Demonstrativo do Quadro de Pessoal",
              Component: PessoalAnaliseHorizontalPage,
              Autorizacao: "101"
            },
            {
              Titulo: "Análise Vertical do Consolidado dos Cargos do Demonstrativo do Quadro de Pessoal",
              Component: PessoalAnaliseVerticalPage,
              Autorizacao: "102"
            },
            {
              Titulo: "Quadro de Pessoal Versus Quadro de Nomeação de Cargos",
              Component: PessoalVersusNomeacaoPage,
              Autorizacao: "103"
            },
            {
              Titulo: "Nomeação de Cargos Versus Sistema SRP",
              Component: PessoalNomeacaoVersusSRPPage,
              Autorizacao: "104"
            },
            {
              Titulo: "Termos de Referência dos Contratos",
              Component: PessoalTermosReferenciaContratoPage,
              Autorizacao: "105"
            },
            {
              Titulo: "Nomeação de Cargos Versus Parametrização de Lotação de Cargo",
              Component: PessoalNomeacaoVersusParametrizacaoPage,
              Autorizacao: "106"
            },
            {
              Titulo: "Demonstrativo de Quadro de Pessoal",
              Component: PessoalQuadroPessoalPage,
              Autorizacao: "107"
            },
            {
              Titulo: "Upload de Documentos",
              Component: ArquivosPage,
              Autorizacao: "108"
            },
            {
              Titulo: "Composição do Quadro de Pessoal",
              Component: PessoalQuadroNomeacaoCargosPage,
              Autorizacao: "110"
            },
            {
              Titulo: "Demonstrativo do Quadro de Pessoal",
              Component: PessoalDemQuadroPessoallPage,
              Autorizacao: "111"
            },
            {
              Titulo: "Termos de Referência de Contratos de Terceirização",
              Component: PessoalContratosTerceirizacaolPage,
              Autorizacao: "112"
            },
            {
              Titulo: "Relação de cargos",
              Component: CargoPage,
              Autorizacao: "109"
            },
            {
              Titulo: "Visão Gerencial das Licitações",
              Component: VisaoGerencialPessoalPage,
              Autorizacao: "100"
            },
            {
              Titulo: "Visão Gerencial das Licitações - Elemento 31",
              Component: VisaoGerencialElemento31Page,
              Autorizacao: "114"
            }
          ]
        },
        {
          Titulo: "Controles Internos",
          Icone: "clipboard",
          Component: ControlesInternosPage,
          Autorizacao: this.autorizacaoControlesInternos,
          NecessarioPCA: true
        },
        {
          Titulo: "Rol de Responsáveis",
          Icone: "filing",
          Component: RolResponsaveisPage,
          Autorizacao: this.autorizacaoRolDeResponsaveis,
          NecessarioPCA: true
        },
        {
          Titulo: "Rol de Assinantes",
          Icone: "cards",
          Component: RolAssinantesPage,
          Autorizacao: this.autorizacaoRolDeAssinantes,
          NecessarioPCA: true
        },
        {
          Titulo: "Processos Correlatos",
          Icone: "albums",
          Component: ProcessosCorrelatosPage,
          Autorizacao: this.autorizacaoProcessosCorrelatos,
          NecessarioPCA: true
        },
        {
          Titulo: "Orçamento",
          Icone: "cash",
          Component: OrcamentoResumoAnalisePage,
          Autorizacao: this.autorizacaoOrcamento,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Upload de Peças Processuais",
              Component: ArquivosPage,
              Autorizacao: "200"
            },
            {
              Titulo: "Análise Diferença na Dotação Inicial",
              Component: diferencaDotacoesPage,
              Autorizacao: "3"
            },
            {
              Titulo: "Consolidação de Despesas Orçamentárias",
              Component: consolidacaoDespesasPage,
              Autorizacao: "4"
            },
            {
              Titulo: "Meta Prevista x Meta Realizada",
              Component: AnaliseMetasPage,
              Autorizacao: "5"
            },
            {
              Titulo: "Percentual da Execução Orçamentária x Meta Física",
              Component: ExecucaoXMetasPage,
              Autorizacao: "6"
            },
            {
              Titulo: "Análise das Despesas de Exercícios Anteriores",
              Component: ExerciciosAnterioresPage,
              Autorizacao: "7"
            },
            {
              Titulo: "Aquisição de Bens x Fonte de Alienação de Ativos",
              Component: AquisicaoBensPage,
              Autorizacao: "8"
            }
          ]
        },
        {
          Titulo: "Contabilidade",
          Icone: "cash",
          Component: ContabilidadeResumoAnalisePage,
          Autorizacao: this.autorizacaoContabilidade,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Análise Horizontal do Balanço DVP",
              Component: AnaliseHorizontalBalancoDvpPage,
              Autorizacao: "1043"
            },
            {
              Titulo: "Análise Vertical do Balanço Patrimonial",
              Component: AnaliseVerticalBalancoPatrimonialPage,
              Autorizacao: "1050"
            },
            {
              Titulo: "Análise Horizontal do Balanço Patrimonial",
              Component: AnaliseHorizontalBalancoPatrimonialPage,
              Autorizacao: "1042"
            },
            {
              Titulo: "Análise Horizontal do Balanço Financeiro",
              Component: AnaliseHorizontalBalancoFinanceiroPage,
              Autorizacao: "1041"
            },
            {
              Titulo: "Balanço Financeiro x Balanço Patrimonial",
              Component: CruzamentoBalancoFinanceiroPatrimonialPage,
              Autorizacao: "1090"
            },
            {
              Titulo: "Execução de Restos a Pagar",
              Component: ExecucaoRestosPagarPage,
              Autorizacao: "1100"
            },
            {
              Titulo: "Análise Horizontal Do Demosntrativo de Fluxo de Caixa",
              Component: AnaliseHorizontalDemonstrativoFluxoCaixaPage,
              Autorizacao: "1044"
            },
            {
              Titulo: "Valores Restituíveis",
              Component: ValoresRestituiveisPage,
              Autorizacao: "1110"
            },
            {
              Titulo: "Saldo de Caixa",
              Component: SaldoCaixaPage,
              Autorizacao: "1120"
            },
            {
              Titulo: "Saldo de Caixa e Equivalente de Caixa",
              Component: SaldoContaPage,
              Autorizacao: "1080"
            },
            {
              Titulo: "Saldo de Caixa e Equivalente de Caixa - SPED",
              Component: SaldoContaSPEDPage,
              Autorizacao: "1081"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço Patrimonial",
              Component: ValidacaoConsistenciaBalancoPatrimonialPage,
              Autorizacao: "1131"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço DVP",
              Component: ValidacaoConsistenciaBalancoDVPPage,
              Autorizacao: "1133"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço Financeiro",
              Component: ValidacaoConsistenciaBalancoFinanceiroPage,
              Autorizacao: "1132"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço DFC",
              Component: ValidacaoConsistenciaBalancoDFCPage,
              Autorizacao: "1134"
            },
            {
              Titulo: "Total de Restos a Pagar Processados",
              Component: TotalRestosPagarProcessadosPage,
              Autorizacao: "1217"
            },
            {
              Titulo: "Total de Restos a Pagar não Processados",
              Component: TotalRestosPagarNaoProcessadosPage,
              Autorizacao: "1218"
            },
            {
              Titulo: "Execução de Restos a Pagar não Processados",
              Component: ExecucaoRestosPagarNaoProcessadosPage,
              Autorizacao: "1219"
            },
            {
              Titulo: "Execução de Restos a Pagar: Saldos do SIAFE X Saldos do Anexo II",
              Component: ExecucaoRestosPagarProcessadosLiquidadosPage,
              Autorizacao: "1220"
            },
            {
              Titulo: "Analise das Contas Bancarias",
              Component: AnaliseContasBancariasPage,
              Autorizacao: "1206"
            },
            {
              Titulo: "Analise dos Saldos Declarados",
              Component: SaldosDeclaradosPage,
              Autorizacao: "1207"
            },
            {
              Titulo: "Peças processuais (Upload de Arquivos)",
              Component: ArquivosPage,
              Autorizacao: "1901"
            },
            {
              Titulo: "Previsão Inicial das Contas Analíticas",
              Component: AnalisePrevisaoInicialContasAnaliticasPage,
              Autorizacao: "1214"
            },
            {
              Titulo: "Saldo das Contas Analíticas",
              Component: SaldoContasAnaliticasPage,
              Autorizacao: "1215"
            },
            {
              Titulo: "Receita Orçamentária Ordinária X Receita Orçamentária Vinculada",
              Component: OrdinariaVsVinculadaPage,
              Autorizacao: "1216"
            },
            {
              Titulo: "Indicadores",
              Component: AnaliseIndicadoresPage,
              Autorizacao: "1223"
            },
            {
              Titulo: "Saldos Virados DVP",
              Component: AnaliseSaldosViradosDVPPage,
              Autorizacao: "1034"
            },
            {
              Titulo: "Saldos Virados Financeiro",
              Component: AnaliseSaldosViradosFinanceiroPage,
              Autorizacao: "1032"
            },
            {
              Titulo: "Saldos Virados Demonstrativo Fluxo de Caixa",
              Component: AnaliseSaldosViradosDemonstrativoFluxoCaixaPage,
              Autorizacao: "1035"
            },
            {
              Titulo: "Saldos Virados Patrimonial",
              Component: AnaliseSaldosViradosPatrimonialPage,
              Autorizacao: "1033"
            },
            {
              Titulo: "Saldos Virados Patrimonial SPED",
              Component: AnaliseSaldosViradosPatrimonialSPEDPage,
              Autorizacao: "1036"
            },
            {
              Titulo: "Saldos Virados Orçamentário",
              Component: AnaliseSaldosViradosOrcamentarioPage,
              Autorizacao: "1031"
            },

            //EGE

            {
              Titulo: "Análise Horizontal do Balanço DVP - EGE",
              Component: AnaliseHorizontalBalancoDvpEGEPage,
              Autorizacao: "1543"
            },
            {
              Titulo: "Análise Vertical do Balanço Patrimonial - EGE",
              Component: AnaliseVerticalBalancoPatrimonialEGEPage,
              Autorizacao: "1550"
            },
            {
              Titulo: "Análise Vertical do Balanço Patrimonial - SPED",
              Component: AnaliseVerticalBalancoPatrimonialSpedPage,
              Autorizacao: "1051"
            },

            {
              Titulo: "Análise Horizontal do Balanço Patrimonial - EGE",
              Component: AnaliseHorizontalBalancoPatrimonialEGEPage,
              Autorizacao: "1542"
            },
            {
              Titulo: "Análise Horizontal do Balanço Financeiro - EGE",
              Component: AnaliseHorizontalBalancoFinanceiroEGEPage,
              Autorizacao: "1541"
            },
            {
              Titulo: "Balanço Financeiro x Balanço Patrimonial - EGE",
              Component: CruzamentoBalancoFinanceiroPatrimonialEGEPage,
              Autorizacao: "1590"
            },
            {
              Titulo: "Execução de Restos a Pagar - EGE",
              Component: ExecucaoRestosPagarEGEPage,
              Autorizacao: "1600"
            },
            {
              Titulo: "Análise Horizontal Do Demosntrativo de Fluxo de Caixa - EGE",
              Component: AnaliseHorizontalDemonstrativoFluxoCaixaEGEPage,
              Autorizacao: "1544"
            },
            {
              Titulo: "Valores Restituíveis - EGE",
              Component: ValoresRestituiveisEGEPage,
              Autorizacao: "1610"
            },
            {
              Titulo: "Saldo de Caixa - EGE",
              Component: SaldoCaixaEGEPage,
              Autorizacao: "1620"
            },
            {
              Titulo: "Saldo de Caixa e Equivalente de Caixa - EGE",
              Component: SaldoContaEGEPage,
              Autorizacao: "1580"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço Patrimonial - EGE",
              Component: ValidacaoConsistenciaBalancoPatrimonialEGEPage,
              Autorizacao: "1631"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço Patrimonial - SPED",
              Component: ValidacaoConsistenciaBalancoPatrimonialSPEDPage,
              Autorizacao: "1135"
            },

            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço DVP - EGE",
              Component: ValidacaoConsistenciaBalancoDVPEGEPage,
              Autorizacao: "1633"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço Financeiro - EGE",
              Component: ValidacaoConsistenciaBalancoFinanceiroEGEPage,
              Autorizacao: "1632"
            },
            {
              Titulo: "Validação de Consistência Entre os Exercícios do Balanço DFC - EGE",
              Component: ValidacaoConsistenciaBalancoDFCEGEPage,
              Autorizacao: "1634"
            },
            {
              Titulo: "Total de Restos a Pagar Processados - EGE",
              Component: TotalRestosPagarProcessadosEGEPage,
              Autorizacao: "1717"
            },
            {
              Titulo: "Total de Restos a Pagar não Processados - EGE",
              Component: TotalRestosPagarNaoProcessadosEGEPage,
              Autorizacao: "1718"
            },
            {
              Titulo: "Execução de Restos a Pagar não Processados - EGE",
              Component: ExecucaoRestosPagarNaoProcessadosEGEPage,
              Autorizacao: "1719"
            },
            {
              Titulo: "Execução de Restos a Pagar: Saldos do SIAFE X Saldos do Anexo II - EGE",
              Component: ExecucaoRestosPagarProcessadosLiquidadosEGEPage,
              Autorizacao: "1720"
            },
            {
              Titulo: "Analise das Contas Bancarias - EGE",
              Component: AnaliseContasBancariasEGEPage,
              Autorizacao: "1706"
            },
            {
              Titulo: "Analise dos Saldos Declarados - EGE",
              Component: SaldosDeclaradosEGEPage,
              Autorizacao: "1707"
            },
            {
              Titulo: "Previsão Inicial das Contas Analíticas - EGE",
              Component: AnalisePrevisaoInicialContasAnaliticasEGEPage,
              Autorizacao: "1714"
            },
            {
              Titulo: "Saldo das Contas Analíticas - EGE",
              Component: SaldoContasAnaliticasEGEPage,
              Autorizacao: "1715"
            },
            {
              Titulo: "Receita Orçamentária Ordinária X Receita Orçamentária Vinculada - EGE",
              Component: OrdinariaVsVinculadaEGEPage,
              Autorizacao: "1716"
            },
            {
              Titulo: "Indicadores - EGE",
              Component: AnaliseIndicadoresEGEPage,
              Autorizacao: "1723"
            },
            {
              Titulo: "Saldos Virados DVP - EGE",
              Component: AnaliseSaldosViradosDVPEGEPage,
              Autorizacao: "1534"
            },
            {
              Titulo: "Saldos Virados Financeiro - EGE",
              Component: AnaliseSaldosViradosFinanceiroEGEPage,
              Autorizacao: "1532"
            },
            {
              Titulo: "Saldos Virados Demonstrativo Fluxo de Caixa - EGE",
              Component: AnaliseSaldosViradosDemonstrativoFluxoCaixaEGEPage,
              Autorizacao: "1535"
            },
            {
              Titulo: "Saldos Virados Patrimonial - EGE",
              Component: AnaliseSaldosViradosPatrimonialEGEPage,
              Autorizacao: "1533"
            },
            {
              Titulo: "Saldos Virados Orçamentário - EGE",
              Component: AnaliseSaldosViradosOrcamentarioEGEPage,
              Autorizacao: "1531"
            },
            //nao funciona abaixo
            {
              Titulo: "Extratos Bancários",
              Component: ArquivosPage,
              Autorizacao: "1903"
            },
            {
              Titulo: "Contas Bancárias ",
              Component: ContasBancariasPage,
              Autorizacao: "1902"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Balanço Orçamentário",
              Component: ValidacaoContasTotalizadorasBalancoOrcamentarioPage,
              Autorizacao: "1020"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Balanço Patrimonial",
              Component: ValidacaoContasTotalizadorasBalancoPatrimonialPage,
              Autorizacao: "1021"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Balanço Financeiro",
              Component: ValidacaoContasTotalizadorasBalancoFinanceiroPage,
              Autorizacao: "1022"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Demonstrativo de Variação Patrimonial",
              Component: ValidacaoContasTotalizadorasDVPPage,
              Autorizacao: "1023"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Demonstrativo de Fluxo de Caixa",
              Component: ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaPage,
              Autorizacao: "1024"
            },

            //EGE
            {
              Titulo: "Validação das Contas Totalizadoras do Balanço Orçamentário - EGE",
              Component: ValidacaoContasTotalizadorasBalancoOrcamentarioEGEPage,
              Autorizacao: "1520"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Balanço Patrimonial - EGE",
              Component: ValidacaoContasTotalizadorasBalancoPatrimonialEGEPage,
              Autorizacao: "1521"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Balanço Financeiro - EGE",
              Component: ValidacaoContasTotalizadorasBalancoFinanceiroEGEPage,
              Autorizacao: "1522"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Demonstrativo de Variação Patrimonial - EGE",
              Component: ValidacaoContasTotalizadorasDVPEGEPage,
              Autorizacao: "1523"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Demonstrativo de Fluxo de Caixa - EGE",
              Component: ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaEGEPage,
              Autorizacao: "1524"
            },
            {
              Titulo: "Validação das Contas Totalizadoras do Balanço Patrimonial - SPED",
              Component: ValidacaoContasTotalizadorasBalancoPatrimonialSPEDPage,
              Autorizacao: "1025"
            },
            {
              Titulo: "Validação das Contas Totalizadoras da Demonstração de Resultado do Exercício - SPED",
              Component: ValidacaoContasTotalizadorasDRESPEDPage,
              Autorizacao: "1026"
            },

            {
              Titulo: "Análise Horizontal do Balanço Patrimonial - SPED",
              Component: AnaliseHorizontalBalancoPatrimonialSpedPage,
              Autorizacao: "1046"
            }
          ]
        },
        {
          Titulo: "Contratos",
          Icone: "albums",
          Component: ContratosPage,
          Autorizacao: this.autorizacaoContratos,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Peças Processuais - Contratos",
              Component: ArquivosPage,
              Autorizacao: "49"
            },
            {
              Titulo: "Lista de Contratos",
              Component: ListaContratosPage,
              Autorizacao: "50"
            },
            {
              Titulo: "Resumo dos Relatórios de Inspeção",
              Component: ResumoRelatorioInspecaoPage,
              Autorizacao: "51"
            },
            {
              Titulo: "Acréscimos ou Supressões de Contratos versus Limite Legal",
              Component: AcrescimosOuSupressoesContratosVersusLimiteLegalPage,
              Autorizacao: "52"
            },
            {
              Titulo: "Extensão de prazos contratuais acima dos limites regulamentados",
              Component: ExtensaoPrazosContratuaisAcimaLimiteRegulamentadoPage,
              Autorizacao: "53"
            },
            {
              Titulo: "Nota de empenho anterior à assinatura do contrato",
              Component: NotaEmpenhoAnteriorAAssinaturaContratoPage,
              Autorizacao: "56"
            },
            {
              Titulo: "Nota de empenho anterior à publicação do contrato",
              Component: NotaEmpenhoAnteriorAPublicacaoContratoPage,
              Autorizacao: "57"
            },
            {
              Titulo: "Nota de empenho posterior à vigência do contrato",
              Component: NotaEmpenhoPosteriorAVigenciaContratoPage,
              Autorizacao: "58"
            },
            {
              Titulo: "Registro de despesas sem contrato, em desacordo com o Art.62 da Lei Federal no8.666/93",
              Component: RegistroDespesasSemContratoDesacordoArt62Page,
              Autorizacao: "54"
            },
            {
              Titulo: "Validação da data de publicação",
              Component: ValidacaoDataPublicacaoPage,
              Autorizacao: "55"
            }
          ]
        },
        {
          Titulo: "Tomada De Contas Especiais",
          Icone: "albums",
          Component: TomadaDeContaResumoAnalisePage,
          Autorizacao: this.autorizacaoTomadaDeConta,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Peças Processuais (Upload de Arquivos)",
              Component: ArquivosPage,
              Autorizacao: "210"
            },
            {
              Titulo: "Tomada de Contas Especial Instauradas no Exercício",
              Component: TomadaDeContaPage,
              Autorizacao: "211"
            },
            {
              Titulo: "Comunicação das Inadimplências à autoridade Administrativa competente (Paragrafo Único, art 41)",
              Component: ConvenioComunicacaoInadimplenciaPage,
              Autorizacao: "212"
            },
            {
              Titulo: "Convênios ou Congêneres com Prestação de Contas Pendentes.",
              Component: TCEConveniosPrestacaoPendentesPage,
              Autorizacao: "250"
            },
            {
              Titulo: "Tomada de Contas Especial encaminhadas fora do prazo legal (Art.14 da IN X/2017)",
              Component: TCEForaDoPrazoPage,
              Autorizacao: "251"
            },
            {
              Titulo: "Tomada de Contas Especial Não Enviadas para o Tribunal de Contas do Estado (Art.14 da IN X/2017)",
              Component: TCENaoEnviadoPage,
              Autorizacao: "252"
            }
          ]
        },
        {
          Titulo: "Transferencias Voluntárias",
          Icone: "albums",
          Component: ConvenioResumoAnalisePage,
          Autorizacao: this.autorizacaoConvenios,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Peças Obrigatórias (Upload de Arquivos)",
              Component: ArquivosPage,
              Autorizacao: "120"
            },
            {
              Titulo: "Relação dos Convênios Celebrados no Período",
              Component: ConvenioRelacaoCelebradosPage,
              Autorizacao: "121"
            },
            {
              Titulo: "Relação dos Convênios Celebrados no Período",
              Component: ArquivosPage,
              Autorizacao: "1211"
            },
            {
              Titulo: "Relação dos Convênios Celebrados no Período",
              Component: ResumoRelatorioInspecaoConveniosPage,
              Autorizacao: "2001"
            },
            {
              Titulo: "Relatório de Auditoria do CGE",
              Component: RelatorioAuditoriaCGEPage,
              Autorizacao: "2002"
            },
            {
              Titulo: "Desconformidade Publicação",
              Component: DesconformidadePublicacaoPage,
              Autorizacao: "2005"
            },
            {
              Titulo: "Celebração de convênios ou aditivos com convenente inadimplente (Art. 40 da Lei Complementar 119/2012)",
              Component: CelebracaoInadimplentePage,
              Autorizacao: "2006"
            },
            {
              Titulo: "Celebração de convênios em parcela única, com prazo superior a 60 dias. (Art. 16)",
              Component: ParcelaUnicaPage,
              Autorizacao: "2007"
            },
            {
              Titulo: "Apresentação de Prestação de Contas de convênios ou instrumentos congêneres Fora do Prazo Legal (Art. 35)",
              Component: ApresentacaoFPrazoPage,
              Autorizacao: "2008"
            },
            {
              Titulo: "Prestação de Contas- Saldos Remanescentes Não Devolvidos Dentro do Prazo Legal (Inciso I Art.39)",
              Component: SaldoRemanescentePage,
              Autorizacao: "2009"
            },
            {
              Titulo: "Prestação de contas com valor superior ao valor liberado",
              Component: PrestacaoSuperiorPage,
              Autorizacao: "2010"
            },
            {
              Titulo: "Prestação de contas com saldo remanescente a devolver",
              Component: SaldosADevolverPage,
              Autorizacao: "2011"
            },
            {
              Titulo: "Prestação de contas analisada fora do prazo legal (Art.37)",
              Component: PrestacaoForaPrazoPage,
              Autorizacao: "2012"
            },
            {
              Titulo: "Convênios celebrados durante período de atraso de análise das prestações de contas (§ Único art. 37)",
              Component: CelebracaoAtrasoPage,
              Autorizacao: "2013"
            },
            {
              Titulo: "Registro Incorreto de Inadimplência pelo Concedente (§ Único art. 39)",
              Component: RegistroIncorretoPage,
              Autorizacao: "2014"
            },
            {
              Titulo: "Convênios ou Instrumentos Congêneres com Inadimplência",
              Component: ConveniosInadimplenciaPage,
              Autorizacao: "2015"
            },
            {
              Titulo: "Comunicação da Inadimplência (§ Único art. 41)",
              Component: ComunicacaoInadimplenciaPage,
              Autorizacao: "2016"
            },
            {
              Titulo: "Nota de empenho anterior à assinatura do convênio, termo de cooperação ou termo de fomento (§ 1º Art. 28)",
              Component: EmpenhoAssinaturaPage,
              Autorizacao: "2017"
            },
            {
              Titulo: "Nota de empenho anterior à publicação do convênio, termo de cooperação ou termo de fomento (§ 1º Art. 28)",
              Component: EmpenhoPublicacaoPage,
              Autorizacao: "2018"
            },
            {
              Titulo: "Nota de empenho posterior ao fim da vigência do convênio, termo de cooperação ou termo de fomento (§ 1º Art. 28)",
              Component: EmpenhoVigenciaPage,
              Autorizacao: "2019"
            },
            {
              Titulo: "Medidas administrativas adotadas fora do prazo legal (Art. 3º § 2º incisos I, II e III da IN X/2017)",
              Component: MedidasForaPrazoPage,
              Autorizacao: "2020"
            }
          ]
        },
        {
          Titulo: "Gestão de Materiais",
          Icone: "albums",
          Component: MateriaisResumoAnalisePage,
          Autorizacao: this.autorizacaoGestaoDeMateriaisEPatrimonio,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Peças Obrigatórias (Upload de Arquivos)",
              Component: ArquivosPage,
              Autorizacao: "168"
            },
            {
              Titulo: "Inventário Sintético de Material de Consumo",
              Component: MateriaisConsumoPage,
              Autorizacao: "161"
            },
            {
              Titulo: "Inventário Sintético de Bens Patrimoniais Móveis",
              Component: BensMateriaisMoveisPage,
              Autorizacao: "162"
            },

            {
              Titulo: "Inventário Sintético de Bens Patrimoniais Imóveis",
              Component: BensMateriaisImoveisPage,
              Autorizacao: "163"
            },
            {
              Titulo: "Inventário Sintético de Bens Intangíveis",
              Component: BensMateriaisIntangiveisPage,
              Autorizacao: "164"
            },
            {
              Titulo: "Alienações Patrimoniais dos Bens Móveis",
              Component: AlienacaoBensMoveisPage,
              Autorizacao: "165"
            },
            {
              Titulo: "Alienações Patrimoniais dos Bens Imóveis",
              Component: AlienacaoBensImoveisPage,
              Autorizacao: "166"
            },
            {
              Titulo: "Baixa de Bens por Doação",
              Component: BensDoacaoPage,
              Autorizacao: "167"
            },
            {
              Titulo: "Indicador de Baixa de Estoque X Aquisições de Estoque",
              Component: BaixaVsAquisicaoPage,
              Autorizacao: "401"
            },
            {
              Titulo: "Baixa x Saldo",
              Component: BaixaVsSaldoAtualPage,
              Autorizacao: "402"
            },
            {
              Titulo: "Relação das Alienações e Doações Realizadas",
              Component: AlienacoesDoacoesPage,
              Autorizacao: "403"
            },
            {
              Titulo: "Análise dos Saldos contábeis - Listas de Bens x Balanço Patrimonial",
              Component: SaldosContabeisPage,
              Autorizacao: "404"
            },
            {
              Titulo: "Reconhecimento do resultado das Alienações",
              Component: ReconhecimentoResultadoPage,
              Autorizacao: "405"
            },
            {
              Titulo: "Análise dos Saldos contábeis - Tabelas x Balancete",
              Component: SaldosContabeisTabelasVsBalancetePage,
              Autorizacao: "407"
            }

          ]
        },
        {
          Titulo: "Arquivos Vinculados",
          Icone: "cash",
          Component: ArquivosPage,
          Autorizacao: this.autorizacaoArquivos,
          NecessarioPCA: true
        },
        {
          Titulo: "Contratos de Gestão",
          Icone: "albums",
          Component: ContratosGestaoResumoAnalisePage,
          Autorizacao: this.autorizacaoContratosDeGestao,
          NecessarioPCA: true,
          Paginas: [
            {
              Titulo: "Upload de Peças Processuais",
              Component: ArquivosPage,
              Autorizacao: "140"
            },
            {
              Titulo: "Cadastro dos Contratos de Gestão",
              Component: CadastroContratosPage,
              Autorizacao: "141"
            },
            {
              Titulo: "Rol de Responsáveis de Contratos de Gestão",
              Component: RolResponsaveisCGPage,
              Autorizacao: "142"
            },
            {
              Titulo: "Relatório Físico Financeiro",
              Component: RelatorioFisicoFinanceiroPage,
              Autorizacao: "143"
            },
            {
              Titulo: "Relatório de Pagamentos Realizados",
              Component: RelatorioPagamentosPage,
              Autorizacao: "144"
            },
            {
              Titulo: "Informações dos Editais/Cotações Realizadas",
              Component: RelatorioEditaisCotacoesPage,
              Autorizacao: "145"
            },
            {
              Titulo: "Relatório de Execução de Receitas e Despesas",
              Component: RelatorioReceitasDespesasPage,
              Autorizacao: "146"
            },
            {
              Titulo: "Informações de Tranferência de Recursos",
              Component: TransferenciaRecursosPage,
              Autorizacao: "147"
            },
            {
              Titulo: "Relação de Pessoal Vinculado à Contratos de Gestão",
              Component: PessoalVinculadoPage,
              Autorizacao: "148"
            },

            {
              Titulo: "Verificação do Rol de Responsáveis",
              Component: VerificacaoRolPage,
              Autorizacao: "150"
            },
            {
              Titulo: "Análise do Relatório Fisico-Financeiro",
              Component: RelatorioFisicoPage,
              Autorizacao: "151"
            },
            {
              Titulo: "Servidores Contemplados na Relação de Pagamentos",
              Component: ServidoresContempladosPagamentosPage,
              Autorizacao: "152"
            },
            {
              Titulo: "Relação de Pagamentos Vs Relação de Pessoal",
              Component: PagamentosVsPessoalPage,
              Autorizacao: "153"
            },
            {
              Titulo: "Pagamento em Desacordo com o Regulamento de Compra da OS",
              Component: PagamentosDesacordoCompraPage,
              Autorizacao: "154"
            },
            {
              Titulo: "Transferencia de recursos entre Contratos de Gestão",
              Component: TransferenciaRecursosAnalistaPage,
              Autorizacao: "155"
            },
            {
              Titulo: "Análise do Relatório de Execução da Receita e Despesa",
              Component: RelatorioReceitaDespesaPage,
              Autorizacao: "156"
            },
            {
              Titulo: "Parcelas Recebidas Vs Valores Empenhados",
              Component: ParcelasRecebidasVsEmpenhoPage,
              Autorizacao: "157"
            },
            {
              Titulo: "Análise das Despesas",
              Component: AnaliseDespesasPage,
              Autorizacao: "158"
            },
            {
              Titulo: "Relação de Pessoal Vinculado à Contratos de Gestão",
              Component: PessoalVinculadoCGPage,
              Autorizacao: "159"
            },
            {
              Titulo: "Análise dos Períodos de Contratação Convergentes",
              Component: VerificacaoContratacaoPage,
              Autorizacao: "160"
            }
          ]
        }
      ]
    }
  ];

  // Retorna lista de rotas
  obtemListaRotas() {
    return this.APP_ROUTERS;
  }

  // Retorna lista de rotas
  obtemListaRotaParaMontarMenu() {
    return this.ROUTERS_TO_MENU;
  }

  obtemPaginaPrincipal() {
    return this.HOME_PAGE;
  }

  obtemPaginaLogoutComponent() {
    return this.LOGOUT_PAGE.Component;
  }

  obtemPaginaLoginComponent() {
    return this.LOGIN_PAGE.Component;
  }

  obtemPaginaAjudaComponent() {
    return this.AJUDA_PAGE.Component;
  }

  // Valida usuario logado
  validadorUsuarioLogado() {

  }

  // Valida Autorização Usuario
  validadorUsuarioAutorizado() {

  }
}



// WEBPACK FOOTER //
// ./src/app/app.routes.ts